<app-modal-base [title]="dialogTitle" (onSubmitEvent)="onSubmit()" [loading]="isLoading" [showLoading]="false"
  [isDisabled]="form.invalid || syncInProgress || (syncDone && (!isFirstSync || syncedWithExistingProperty))"
  [submitText]="submitLabel" cancelType="CLOSE"
  [isCancelDisabled]="syncInProgress || (syncDone && isFirstSync && !syncedWithExistingProperty)">
  <ng-container main *ngTemplateOutlet="content"></ng-container>
  <ng-container footer *ngTemplateOutlet="footerContent"></ng-container>
</app-modal-base>

<ng-template #content>
  <div mat-dialog-content>
    <p><span class="title">Nom du bien:</span> {{ data.connectorProperty.name }}</p>
    <p *ngIf="data.connectorProperty.eemoProp">Synchronisé avec le bien EEMO <a
        [routerLink]="['/property', data.connectorProperty.eemoProp.uid]">{{data.connectorProperty.eemoProp.name}}</a>
    </p>
    <form [formGroup]="form">
      <div *ngIf="isFirstSync" class="formContainer d-flex justify-content-center p-3 ">
        <mat-form-field class="col-12 col-sm-8">
          <mat-label>Cible</mat-label>
          <mat-select formControlName="existingProperty" required placeholder="">
            <mat-option value="NEW">Nouveau bien</mat-option>
            <mat-option *ngFor="let prop of availableExistingProperty" [value]="prop.uid">
              {{ availableExistingPropertyNames[prop.uid] }}</mat-option>
          </mat-select></mat-form-field>
      </div>
      <div class="d-flex justify-content-center" *ngIf="form_existingProperty.value!=='NEW'">
        <p class="info">Les informations de base du bien existant (nom, adresse, localisation)
          ne seront pas mises à jour.</p>
      </div>
      <div class="formContainer d-flex flex-column justify-content-center mt-3">
        <!-- FIXME Not Used
        <div class="form-group">
          <mat-checkbox formControlName="syncCoreInfos">{{'connectorSyncDialog.syncCoreInfos' | translate}}
          </mat-checkbox>
        </div>-->
        <div class="form-group">
          <mat-checkbox formControlName="syncAttributes">{{'connectorSyncDialog.syncAttributes' | translate}}
          </mat-checkbox>
        </div>
        <div class="form-group">
          <mat-checkbox formControlName="syncPhotos">{{'connectorSyncDialog.syncPhotos' | translate}}
          </mat-checkbox>
        </div>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #footerContent>
  <div class="text-center">
    <div *ngIf="currentSync?.state === ActionState.IN_PROGRESS" class="mb-3">
      <p>{{'connectorSyncDialog.syncInProgress' | translate}}</p>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
    <div *ngIf="currentSync?.state === ActionState.SUCCESS">
      <p>{{'connectorSyncDialog.syncSuccess' | translate}}</p>
      <p *ngIf="isFirstSync && !syncedWithExistingProperty">{{'connectorSyncDialog.syncNext' | translate}}</p>
    </div>
  </div>
  <div *ngIf="currentSync?.state === ActionState.ERROR">
    <p class="alert-danger"> {{'connectorSyncDialog.syncError' | translate}} {{currentSync?.error}}</p>
  </div>
</ng-template>
